import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

/*
 * PLACEHOLDER PROOF SECTION.
 * Replace TESTIMONIALS quotes/attributions with real client quotes,
 * and swap the CLIENTS text wordmarks for real logo <img> tags when available.
 */

const CLIENTS = ["Education", "Healthcare", "Nonprofits", "Corporate", "Conferences", "Faith & Community"];

const TESTIMONIALS = [
  {
    testid: "testimonial-1",
    quote:
      "Casey didn't just speak — he shifted the whole room. Our staff left calmer, more connected, and genuinely re-energized. Weeks later, people are still talking about it.",
    role: "Wellness Director",
    org: "Regional Healthcare System",
  },
  {
    testid: "testimonial-2",
    quote:
      "The drumming experience reached students that traditional programs never could. We saw more focus and real connection in one session than we'd built in months.",
    role: "Program Coordinator",
    org: "Public School District",
  },
  {
    testid: "testimonial-3",
    quote:
      "Our team came in stressed and siloed. They left in sync — laughing, collaborating, and fully present. Best culture investment we've made this year.",
    role: "People & Culture Lead",
    org: "Corporate Team",
  },
];

const Card = ({ t, index }) => (
  <motion.figure
    data-testid={t.testid}
    className="flex flex-col rounded-3xl border border-[#AEE6D5]/15 bg-[#0B3B3C]/70 p-8"
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.7, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
  >
    <Quote className="h-8 w-8 text-[#D4AF37]/70" strokeWidth={1.4} />
    <div className="mt-5 flex gap-1" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((s) => (
        <Star key={s} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
      ))}
    </div>
    <blockquote className="mt-5 flex-1 text-base leading-relaxed text-[#F8FAFC]/85">“{t.quote}”</blockquote>
    <figcaption className="mt-6 border-t border-[#AEE6D5]/12 pt-5">
      <p className="font-serif text-lg text-[#F8FAFC]">{t.role}</p>
      <p className="mt-0.5 font-mono text-[0.6rem] uppercase tracking-[0.18em] text-[#AEE6D5]">{t.org}</p>
    </figcaption>
  </motion.figure>
);

export const Testimonials = () => (
  <section className="relative z-10 bg-[#0A2E2C] px-6 py-20 sm:px-10 lg:px-12 lg:py-32" data-testid="testimonials">
    <div className="mx-auto max-w-6xl">
      <div className="mb-12 max-w-3xl">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.3em] text-[#D4AF37]">Proof in the room</p>
        <h2 className="mt-4 font-serif text-4xl font-light leading-[1.05] tracking-tight text-[#F8FAFC] sm:text-5xl">
          What partners say after the <span className="italic text-[#AEE6D5]">rhythm settles.</span>
        </h2>
      </div>

      {/* trusted-by strip (swap text wordmarks for real client logos) */}
      <div className="mb-14" data-testid="client-logos">
        <p className="text-center font-mono text-[0.6rem] uppercase tracking-[0.22em] text-[#F8FAFC]/45">
          Trusted by organizations across
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 sm:gap-x-12">
          {CLIENTS.map((c) => (
            <span
              key={c}
              className="font-serif text-lg italic text-[#AEE6D5]/55 transition-colors hover:text-[#AEE6D5] sm:text-xl"
            >
              {c}
            </span>
          ))}
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => <Card key={t.testid} t={t} index={i} />)}
      </div>
    </div>
  </section>
);
